//Faiz Saeed 23/12/23 Tabs for OutreachCampaignActivity
import React from 'react';

import { Row } from '@unthinkable/react-core-components';
import { getPreviousMonth } from '@unthinkable/react-filters/src/DateUtility';
import { AddButton } from '../../../components/button/AddButton';
import {
    GroupFilter,
} from '../../../components/filter/Filters';
import { TabView } from '../../../components/tab/TabView';
import { useFilter } from '../../../controllers/useFilter';
import { OutreachCampaignActivityTable } from './OutreachCampaignActivityTable';

export const OutreachCampaignActivityTabs = props => {
  const {
    route: {params},
    navigation,
  } = props;
  const {
    onChangeFilter,
    searchValue,
    applyFilter,
    filterValues = {},
  } = useFilter({
    params: {
      period: params.period || getPreviousMonth(),
      target_audience: params?.target_audience || {},
    },
  });
  const {filter, params: filterParams} = filterValues || {};
  const tabs = {
    inexperiment: {
      label: 'In Experiment',
      view: (
        <OutreachCampaignActivityTable
          filterParams={filterParams}
          filter={filter}
          searchValue={searchValue}
          tabFilter={{
            status: 'In Experiment',
          }}
        />
      ),
    },
    confirmed: {
      label: 'Confirmed',
      view: (
        <OutreachCampaignActivityTable
          filterParams={filterParams}
          filter={filter}
          searchValue={searchValue}
          tabFilter={{
            status: 'Confirmed',
          }}
        />
      ),
    },

    retired: {
      label: 'Retired',
      view: (
        <OutreachCampaignActivityTable
          filterParams={filterParams}
          filter={filter}
          searchValue={searchValue}
          tabFilter={{status: 'Retired'}}
        />
      ),
    },
    failed: {
      label: 'Failed',
      view: (
        <OutreachCampaignActivityTable
          filterParams={filterParams}
          filter={filter}
          searchValue={searchValue}
          tabFilter={{status: 'Failed'}}
        />
      ),
    },
  };
  const actions = [
    <GroupFilter
      filterValues={filterValues}
      applyFilter={applyFilter}
      filters={[
        {
          type: 'autoComplete',
          label: 'Owner',
          api: '/employeeSuggestions',
          placeholder: 'Select',
          suggestionField: 'name',
          valueField: 'name',
          field: 'assigned_to',
        },
      ]}
    />,
    <Row
      gap={8}
      style={{alignItems: 'center', justifyContent: 'space-between'}}>
      <AddButton
        title="Campaign"
        view="add-outreachcampaign"
        params={props?.route?.params}
      />
    </Row>,
  ];
  return <TabView {...props} tabs={tabs} actions={actions} />;
};
